import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Text, IconWarningAmber, Box } from '@machobear/design-system'
import { vars } from '@machobear/design-system/css'
import { InsightBlock } from '../insight-block'

// DS doesn't support text fragments of different colors in the same string
const CautionText = styled.span`
  color: ${vars.foregroundColor.caution};
`

interface Props {
  averagePrice: number
  priceDifference: number
}

export const LowPriceWarning = ({ averagePrice, priceDifference }: Props) => {
  const { t } = useTranslation()

  return (
    <InsightBlock
      icon={<IconWarningAmber tone="caution" size="small" />}
      testId="listing-price-insight"
    >
      <Box display="flex" flexDirection="column" justifyContent="center">
        <Text weight="medium">{t('Consider increasing your rental price')}</Text>
      </Box>

      <span style={{ margin: 0, padding: 0 }}>
        <CautionText>
          {Math.abs(priceDifference)}% {t('lower')}{' '}
        </CautionText>
        {t('l.listing.view.price_lower_than_average.text', {
          defaultValue:
            'than the average rent price of similar listings near you: ${{averagePrice}}/sqft.',
          averagePrice
        })}
      </span>
    </InsightBlock>
  )
}
